export default __webpack_public_path__ + "media/images/icons/icon-arrow-slider-right-bd536146943f8a5e3b09a57b1fed610e.svg";